import {Navigate, useSearchParams} from 'react-router-dom';

import {resolveGuestReturnTo} from '@/features/guest';

import type {FC} from 'react';

/** `/guest` itself, after sign-in: an invite link's account, else the guest's list. */
export const GuestEntryPage: FC = () => {
  const [searchParams] = useSearchParams();

  return <Navigate to={resolveGuestReturnTo(searchParams.get('account'))} replace />;
};
